import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftNotch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 127,
	viewBox: "0 0 36 127",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M35.6006 119V8C35.6006 3.58172 32.0189 0 27.6006 0H8.00683C2.4594 0 -1.40417 5.5086 0.485024 10.7244L18.6138 60.7756C19.2514 62.5359 19.2514 64.4641 18.6138 66.2244L0.485026 116.276C-1.40417 121.491 2.45939 127 8.00682 127H27.6006C32.0189 127 35.6006 123.418 35.6006 119Z",
		fill: "currentColor"
	})
});
export default SvgLeftNotch;
